// extracted by mini-css-extract-plugin
export default {"addToCartControl":"A1-z","giftCard":"B1-z","btnContainer":"C1-z","cartButton":"D1-z","disabled":"E1-z"};